module.exports = __webpack_public_path__ + "static/media/Internal French doors (2).3d3ae98f.jpg";